import React, { FC } from 'react';

import { Container, ContainerProps } from '@lglp/components';
import { useTranslation } from 'react-i18next';

import { HEADER } from 'translations';

import CloseIcon from '../../../../components/icons/CloseIcon';
import styles from './CloseMenu.module.scss';
import { useDesktopContext } from './DesktopContext';

export const CloseMenu: FC<CloseMenuProps> = ({ className }) => {
  const { t } = useTranslation();
  const { close } = useDesktopContext();

  return (
    <Container
      className={[className, styles.closeButton]}
      onClick={() => close()}
    >
      {t(HEADER.MENU_CLOSE)}
      <CloseIcon className={styles.closeIcon} />
    </Container>
  );
};

type CloseMenuProps = ContainerProps & {};
